import { DonatePage } from "@fwa/src/components/DonatePage";
import Head from "next/head";

const Page = () => (
  <>
    <Head>
      <meta name="robots" content="noindex" />
    </Head>
    <DonatePage />
  </>
);

export default Page;
